import bookReducer from "./books/bookReducer";
import filterReducer from "./filters/filtersReducer";
import { combineReducers } from "redux";

const rootReducer = combineReducers({
  books: bookReducer,
  filters: filterReducer,
});

export default rootReducer;
